import { CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AuthSessionService } from '../services/auth-session.service';
import { LocaleService } from '../../services/locale.service';

export const authenticationGuard: CanActivateChildFn = async (childRoute) => {
  const authSessionService = inject(AuthSessionService);
  const router = inject(Router);
  const localeService = inject(LocaleService);

  const routePath = childRoute.routeConfig?.path;
  if (routePath === 'unauthorized') {
    return true;
  }

  await authSessionService.initialize();

  if (authSessionService.hasExternalRedirectStarted()) {
    return false;
  }

  if (!authSessionService.isAuthEnabled()) {
    return true;
  }

  if (authSessionService.isAuthenticated()) {
    return true;
  }

  if (authSessionService.shouldFailToUnauthorized()) {
    return router.parseUrl(localeService.stripSupportedLocalePrefix(localeService.withLocalePath('/unauthorized')));
  }

  await authSessionService.login();
  return false;
};